const init = function () {
    const toggles = document.querySelectorAll('[data-sidebar-menu-toggle]');

    toggles.forEach(function (toggle) {
        const targetSelector = toggle.getAttribute('data-sidebar-menu-target');
        const target = targetSelector ? document.querySelector(targetSelector) : null;

        if (!target || !window.bootstrap?.Collapse) return;

        const collapse = window.bootstrap.Collapse.getOrCreateInstance(target, {
            toggle: false,
        });

        target.addEventListener('shown.bs.collapse', function () {
            toggle.classList.remove('collapsed');
            toggle.setAttribute('aria-expanded', 'true');
        });

        target.addEventListener('hidden.bs.collapse', function () {
            toggle.classList.add('collapsed');
            toggle.setAttribute('aria-expanded', 'false');
        });

        toggle.addEventListener('click', function () {
            collapse.toggle();
        });
    });
}

export default {init};
